export class LinksPDF {

    static linksPDFLista: LinksPDF[] = [
        { tipo: 'docLink', descricao: 'Manual de Governança Corporativa', caminho: 'https://www.centrus.org.br/wp-content/uploads/2020/08/governanca_corporativa_21082019.pdf' },
        { tipo: 'pdf', descricao: 'Regulamento de Segurança em TI', caminho: 'regulamento_ti_rsti_2017.pdf' }

    ];

    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string
    ) {

    }



}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/links-pdf.ts